import ReactGA from "react-ga4";

export const initGA = (trackingId: string) => {
  ReactGA.initialize(trackingId);
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
//   ReactGA.pageview(window.location.pathname);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "." });

};

export const addToCart = () => {
  ReactGA.set({ page: window.location.pathname });
//   ReactGA.pageview(window.location.pathname);
    ReactGA.send({ hitType: "pageview", 
    page: window.location.pathname,
     title: "." });

};


export const gaEvent = (category: string, eventName: string, event_parameters: any, label: string) => {
  ReactGA.event({
    category: category,
    action: eventName,
    label: label,
    nonInteraction: false,
    ...event_parameters
  });
};
